import { render } from "./CourseManagementModal.vue?vue&type=template&id=48e763b6&scoped=true"
import script from "./CourseManagementModal.vue?vue&type=script&lang=js"
export * from "./CourseManagementModal.vue?vue&type=script&lang=js"

import "./CourseManagementModal.vue?vue&type=style&index=0&id=48e763b6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48e763b6"]])

export default __exports__